module.exports = __webpack_public_path__ + "img/cel-imei.f47166b0.svg";